import pendingSubmissionsCountSelectorFactory from '../../gridReport/pendingSubmissionsCountSelectorFactory';
import { isAllowedToMakeDirectEntriesSelectorFactory } from '../../store/selectors';

export const selectReportData = ({ balanceSheetManagement }) => balanceSheetManagement.taxReserve.reportData;

export const selectIsFetchingTaxReservesReport = ({ balanceSheetManagement }) =>
  balanceSheetManagement.taxReserve.isFetchingReportData;

export const isExportingTaxReserveReportSelector = ({ balanceSheetManagement }) =>
  balanceSheetManagement.taxReserve.isExportingReport;

export const pendingSubmissionsCountSelector = ({ balanceSheetManagement }) =>
  pendingSubmissionsCountSelectorFactory(balanceSheetManagement.taxReserve.reportData);

export const isAllowedToMakeDirectEntriesSelector = isAllowedToMakeDirectEntriesSelectorFactory({
  checkAggregationDroplistValue: false,
});

export const obligationsSelector = ({ administration }) =>
  administration.obligations.obligations;

export const periodOrCurrentSelector = ({ shared }) => shared.period || shared.currentPeriod;
